import categories from './categories';
import mails from './mails';
import orders from './orders';
import backlinks from './backlinks';

export default {
  categories,
  mails,
  orders,
  backlinks
};
